module.exports = __webpack_public_path__ + "static/media/map_icon_gray.4ce80117.svg";